/*
 * Ryan O'Dowd
 * 2025-07-20
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

export const appleAuth: any = {};
export const appleAuthAndroid: any = {};
